/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: HGQcTj4KAvT6
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicSignupProgressBar.module.css"; // plasmic-import: HGQcTj4KAvT6/css

createPlasmicElementProxy;

export const PlasmicSignupProgressBar__VariantProps = new Array("type");

export const PlasmicSignupProgressBar__ArgProps = new Array("stepsMap2");

const $$ = {};

function PlasmicSignupProgressBar__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.type
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"stepsWrapper"}
      data-plasmic-override={overrides.stepsWrapper}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.stepsWrapper
      )}
    >
      {renderPlasmicSlot({
        defaultContents: null,
        value: args.stepsMap2
      })}
    </div>
  );
}

const PlasmicDescendants = {
  stepsWrapper: ["stepsWrapper"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSignupProgressBar__ArgProps,
          internalVariantPropNames: PlasmicSignupProgressBar__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSignupProgressBar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "stepsWrapper") {
    func.displayName = "PlasmicSignupProgressBar";
  } else {
    func.displayName = `PlasmicSignupProgressBar.${nodeName}`;
  }
  return func;
}

export const PlasmicSignupProgressBar = Object.assign(
  // Top-level PlasmicSignupProgressBar renders the root element
  makeNodeComponent("stepsWrapper"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicSignupProgressBar
    internalVariantProps: PlasmicSignupProgressBar__VariantProps,
    internalArgProps: PlasmicSignupProgressBar__ArgProps
  }
);

export default PlasmicSignupProgressBar;
/* prettier-ignore-end */
